<template>
    <van-tabbar v-model="bus.state.tabBarActive" v-show="bus.state.showBar">
        <van-tabbar-item icon="wap-home-o" url="/#/home" value="0">首页</van-tabbar-item>
        <van-tabbar-item icon="apps-o" url="/#/classification" value="1">分类</van-tabbar-item>
        <van-tabbar-item v-if="!(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0)" icon="../../img/icons/zg.png" url="/#/direct-purchase" value="2">分货直购</van-tabbar-item>
        <template v-if="!(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0)" >
        <template v-if="bus.state.cartGoodsNum>0">
            <van-tabbar-item icon="shopping-cart-o" url="/#/carts" :info="bus.state.cartGoodsNum" value="3">购物车</van-tabbar-item>
        </template>
        <template v-else>
            <van-tabbar-item icon="shopping-cart-o" url="/#/carts" value="3">购物车</van-tabbar-item>
        </template>
        </template>
        <van-tabbar-item icon="contact" url="/#/user" value="4">我的</van-tabbar-item>
    </van-tabbar>
</template>

<script>
  import bus from '../bus'

  export default {
    data() {
      return {
        bus
      }
    }
  }
</script>

<style lang="less" scoped>
    .van-tabbar-item--active {
        color: #f44;
    }
</style>
